module.exports = __webpack_public_path__ + "images/feature/0710_@_1-ba1daa8d12a93a88ea1fb075cc1ea1f3.png";